import axios from "axios";
import React, { useContext, useEffect, useState, useRef } from "react";
import homeslider1 from "../../assets/image/newhomeslider1.webp";
import homeslider2 from "../../assets/image/newhomeslider2.webp";
import homeslider3 from "../../assets/image/newhomeslider3.webp";
import homeslider4 from "../../assets/image/newhomeslider4.webp";

import homeslider5 from "../../assets/image/homeslider5.webp";
import homeslider6 from "../../assets/image/homeslider6.webp";
import { NavLink } from "react-router-dom";
import translations from "../../data/langData";
import { LanguageContext } from "../../context/LanguageContext";
import LazyLoad from "react-lazy-load";
import ApiLinkContext from "../../context/ApiLinkContext";

import { Swiper, SwiperSlide } from "swiper/react";

import slider1 from "../../assets/image/slider1.webp";
import slider2 from "../../assets/image/slider2.webp";
import slider3 from "../../assets/image/slider3.webp";
import slider4 from "../../assets/image/slider4.webp";
import slider5 from "../../assets/image/slider5.webp";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay, Navigation } from "swiper/modules";



const Slider = () => {
  const { data } = useContext(ApiLinkContext);
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  // Parallax effect state
  const [scrollY, setScrollY] = useState(0);
  const sliderRef = useRef(null);

  // Scroll event handler for parallax effect
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Calculate parallax values
  const getParallaxStyles = () => {
    if (!sliderRef.current) return {};

    const sliderRect = sliderRef.current.getBoundingClientRect();
    const sliderTop = sliderRect.top;
    const sliderHeight = sliderRect.height;

    // Calculate scroll progress (0 to 1)
    const scrollProgress = Math.max(0, Math.min(1, -sliderTop / sliderHeight));

    // Background opacity decreases (darkens) as we scroll
    const backgroundOpacity = Math.max(0.2, 1 - scrollProgress * 0.8);

    // Text starts lower and moves up to center as we scroll
    // Start 80px below center, move up to perfect center (translateY(0))
    const textTransform = `translateY(${-scrollProgress * 250}px)`;

    return {
      backgroundOpacity,
      textTransform,
      scrollProgress,
    };
  };

  const parallaxStyles = getParallaxStyles();
  return (
    <>
      <div
        className="tf-slideshow slider-home-4 slider-effect-fade position-relative"
        ref={sliderRef}
      >
        <Swiper
          pagination={true}
          modules={[Autoplay, Pagination]}
          className="mySwiper"
          //  navigation={true}

          slidesPerView={1}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
        >
          {/* <SwiperSlide>
            <div className="swiper tf-sw-slideshow">
              <div className="swiper-wrapper1">
                <div className="swiper-slide1">
                  <div className="wrap-slider1 " id="homeslider">
                    <LazyLoad>
                      <img
                        className="lazyload img-fluid aboutDesc newYearImg w-100"
                        style={{
                          objectFit: "cover",
                          opacity: parallaxStyles.backgroundOpacity || 1,
                          transition: "opacity 0.1s ease-out",
                        }}
                        src={homeslider6}
                        alt="fashion-slideshow"
                      />
                    </LazyLoad>
                    <div
                      className="sliderTitle "
                      style={{
                        transform:
                          parallaxStyles.textTransform || "translateY(0)",
                        transition: "transform 0.1s ease-out",
                      }}
                    >
                      <h2
                        style={{ fontWeight: "600" }}
                        className="text-center animate__animated animate__fadeInUp animate__delay-1s aboutDesc my-2 text-white"
                      >
                        {t.homeSlider6}
                      </h2>
                      <div className="d-flex justify-content-center align-items-center animate__animated animate__fadeInUp animate__delay-2s aboutDesc my-2 text-white">
                        <div style={{ width: "700px" }}>
                          <p
                            className="text-center text-white"
                            dangerouslySetInnerHTML={{
                              __html: t.homeSlider6Desc,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="outline"></div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide> */}
          <SwiperSlide>
            <div
              className="swiper tf-sw-slideshow"
            >
              <div className="swiper-wrapper1">
                <div className="swiper-slide1" >
                  <div className="wrap-slider1 " id="homeslider">
                    <LazyLoad>
                      <img
                        className="lazyload img-fluid aboutDesc newYearImg w-100"
                        style={{ objectFit: "cover" }}
                        src={slider1}
                        alt="fashion-slideshow"
                      />
                    </LazyLoad>
                    <div className="sliderTitle ">
                      <h6 dangerouslySetInnerHTML={{ __html: t.homeSlider3 }} className="animate__animated animate__fadeInUp animate__delay-1s aboutDesc my-2 text-uppercase" />
                      <h6 style={{ fontSize: "20px" }} className="text-white animate__animated animate__fadeInUp animate__delay-1s aboutDesc my-2 " dangerouslySetInnerHTML={{ __html: t.homeSlider3Desc }} />
                      {language == "az" ? (
                        <div className="d-flex">
                          <NavLink to="/collections">
                            <button
                              className="animate__animated animate__fadeInUp animate__delay-1s"
                              id="exploreMore"
                            >
                              {t.explore}
                            </button>
                          </NavLink>
                          <NavLink to="/mobil-telefonlar" className="d-flex justify-content-start">
                            <button className="animate__animated animate__fadeInUp animate__delay-1s mx-3">
                              {t.buynow}
                            </button>
                          </NavLink>
                        </div>
                      ) : (
                        <div className="d-flex">
                          <NavLink>
                            <button
                              className="animate__animated animate__fadeInUp animate__delay-1s"
                              id="exploreMore"
                            >
                              {t.explore}
                            </button>
                          </NavLink>
                          <NavLink to="/mobil-telefonlar" className="d-flex justify-content-start">
                            <button className="animate__animated animate__fadeInUp animate__delay-1s mx-3">
                              {t.buynow}
                            </button>
                          </NavLink>
                        </div>
                      )}

                    </div>
                    <div className="outline"></div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>


          <SwiperSlide>
            <div
              className="swiper tf-sw-slideshow"
            >
              <div className="swiper-wrapper1">
                <div className="swiper-slide1" >
                  <div className="wrap-slider1 " id="homeslider">
                    <LazyLoad>
                      <img
                        className="lazyload img-fluid aboutDesc newYearImg w-100"
                        style={{ objectFit: "cover" }}
                        src={slider2}
                        alt="fashion-slideshow"
                      />
                    </LazyLoad>
                    <div className="sliderTitle ">
                      <h6 dangerouslySetInnerHTML={{ __html: t.homeSlider2 }} className=" animate__animated animate__fadeInUp animate__delay-1s aboutDesc my-2 text-uppercase" />
                      <h6 style={{ fontSize: "20px" }} className="text-white" dangerouslySetInnerHTML={{ __html: t.homeSlider2Desc }} />

                      {language == "az" ? (
                        <div className="d-flex">
                          <NavLink to="/collections">
                            <button
                              className="animate__animated animate__fadeInUp animate__delay-1s"
                              id="exploreMore"
                            >
                              {t.explore}
                            </button>
                          </NavLink>
                          <NavLink to="/mobil-telefonlar" className="d-flex justify-content-start">
                            <button className="animate__animated animate__fadeInUp animate__delay-1s mx-3">
                              {t.buynow}
                            </button>
                          </NavLink>
                        </div>
                      ) : (
                        <div className="d-flex">
                          <NavLink>
                            <button
                              className="animate__animated animate__fadeInUp animate__delay-1s"
                              id="exploreMore"
                            >
                              {t.explore}
                            </button>
                          </NavLink>
                          <NavLink to="/quantum" className="d-flex justify-content-start">
                            <button className="animate__animated animate__fadeInUp animate__delay-1s mx-3">
                              {t.buynow}
                            </button>
                          </NavLink>
                        </div>
                      )}

                    </div>
                    <div className="outline"></div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>

            <div
              className="swiper tf-sw-slideshow"
            >
              <div className="swiper-wrapper1">
                <div className="swiper-slide1" >
                  <div className="wrap-slider1 " id="homeslider">
                    <LazyLoad>
                      <img
                        className="lazyload img-fluid aboutDesc newYearImg w-100"
                        style={{ objectFit: "cover" }}
                        src={slider3}
                        alt="fashion-slideshow"
                      />
                    </LazyLoad>
                    <div className="sliderTitle ">
                      <h6 dangerouslySetInnerHTML={{ __html: t.springBloom }} className=" animate__animated animate__fadeInUp animate__delay-1s aboutDesc my-2 text-uppercase" />
                      <h6 style={{ fontSize: "20px" }} className="text-white" dangerouslySetInnerHTML={{ __html: t.spring1 }} />
                      {language == "az" ? (
                        <div className="d-flex">
                          <NavLink to="/collections">
                            <button
                              className="animate__animated animate__fadeInUp animate__delay-1s"
                              id="exploreMore"
                            >
                              {t.explore}
                            </button>
                          </NavLink>
                          <NavLink to="/mobil-telefonlar" className="d-flex justify-content-start">
                            <button className="animate__animated animate__fadeInUp animate__delay-1s mx-3">
                              {t.buynow}
                            </button>
                          </NavLink>
                        </div>
                      ) : (
                        <div className="d-flex">
                          <NavLink>
                            <button
                              className="animate__animated animate__fadeInUp animate__delay-1s"
                              id="exploreMore"
                            >
                              {t.explore}
                            </button>
                          </NavLink>
                          <NavLink to="/mobil-telefonlar" className="d-flex justify-content-start">
                            <button className="animate__animated animate__fadeInUp animate__delay-1s mx-3">
                              {t.buynow}
                            </button>
                          </NavLink>
                        </div>
                      )}

                    </div>
                    <div className="outline"></div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div
              className="swiper tf-sw-slideshow"
            >
              <div className="swiper-wrapper1">
                <div className="swiper-slide1" >
                  <div className="wrap-slider1 " id="homeslider">
                    <LazyLoad>
                      <img
                        className="lazyload img-fluid aboutDesc newYearImg w-100"
                        style={{ objectFit: "cover" }}
                        src={slider4}
                        alt="fashion-slideshow"
                      />
                    </LazyLoad>
                    <div className="sliderTitle ">
                      <h6 dangerouslySetInnerHTML={{ __html: t.homeSlider4 }} className=" animate__animated animate__fadeInUp animate__delay-1s aboutDesc my-2 text-uppercase" />
                      <h6 style={{ fontSize: "20px" }} className="text-white" dangerouslySetInnerHTML={{ __html: t.homeSlider4Desc }} />


                      {language == "az" ? (
                        <div className="d-flex">
                          <NavLink to="/collections">
                            <button
                              className="animate__animated animate__fadeInUp animate__delay-1s"
                              id="exploreMore"
                            >
                              {t.explore}
                            </button>
                          </NavLink>
                          <NavLink to="/mobil-telefonlar" className="d-flex justify-content-start">
                            <button className="animate__animated animate__fadeInUp animate__delay-1s mx-3">
                              {t.buynow}
                            </button>
                          </NavLink>
                        </div>
                      ) : (
                        <div className="d-flex">
                          <NavLink>
                            <button
                              className="animate__animated animate__fadeInUp animate__delay-1s"
                              id="exploreMore"
                            >
                              {t.explore}
                            </button>
                          </NavLink>
                          <NavLink to="/mobil-telefonlar" className="d-flex justify-content-start">
                            <button className="animate__animated animate__fadeInUp animate__delay-1s mx-3">
                              {t.buynow}
                            </button>
                          </NavLink>
                        </div>
                      )}

                    </div>
                    <div className="outline"></div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div
              className="swiper tf-sw-slideshow"
            >
              <div className="swiper-wrapper1">
                <div className="swiper-slide1" >
                  <div className="wrap-slider1 " id="homeslider">
                    <LazyLoad>
                      <img
                        className="lazyload img-fluid aboutDesc newYearImg w-100"
                        style={{ objectFit: "cover" }}
                        src={slider5}
                        alt="fashion-slideshow"
                      />
                    </LazyLoad>
                    <div className="sliderTitle ">
                      <h6 dangerouslySetInnerHTML={{ __html: t.homeSlider5 }} className=" animate__animated animate__fadeInUp animate__delay-1s aboutDesc my-2 text-uppercase" />
                      <h6 style={{ fontSize: "20px" }} className="text-white" dangerouslySetInnerHTML={{ __html: t.homeSlider5Desc }} />


                      {language == "az" ? (
                        <div className="d-flex">
                          <NavLink to="/collections">
                            <button
                              className="animate__animated animate__fadeInUp animate__delay-1s"
                              id="exploreMore"
                            >
                              {t.explore}
                            </button>
                          </NavLink>
                          <NavLink to="/mobil-telefonlar" className="d-flex justify-content-start">
                            <button className="animate__animated animate__fadeInUp animate__delay-1s mx-3">
                              {t.buynow}
                            </button>
                          </NavLink>
                        </div>
                      ) : (
                        <div className="d-flex">
                          <NavLink>
                            <button
                              className="animate__animated animate__fadeInUp animate__delay-1s"
                              id="exploreMore"
                            >
                              {t.explore}
                            </button>
                          </NavLink>
                          <NavLink to="/mobil-telefonlar" className="d-flex justify-content-start">
                            <button className="animate__animated animate__fadeInUp animate__delay-1s mx-3">
                              {t.buynow}
                            </button>
                          </NavLink>
                        </div>
                      )}

                    </div>
                    <div className="outline"></div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>

      <div className="tf-marquee marquee-sm bg_blue-3">
        <div className="wrap-marquee">
          {data.map((i, index) => (
            <div className="marquee-item" key={index}>
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={7}
                  height={6}
                  viewBox="0 0 7 6"
                  fill="none"
                >
                  <path d="M3.5 0L6.53109 5.25H0.468911L3.5 0Z" fill="white" />
                </svg>
              </div>
              <p className="text text-white text-uppercase fw-6 aboutDesc">
                {i.name_show.split(" (")[0]}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Slider;
